import axios from 'axios';

const reportsUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/reports`;

export const getReports = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data
        .filter((element) => element.name !== 'Dashboard')
        .filter((element) => element.name !== 'Error Triunfo Motos')
        .filter((element) => element.name !== 'Ventas Voy En Bus')
        .filter((element) => element.name !== 'Reporte Altas GigaRed')
        .filter((element) => element.name !== 'Bajas Socios')
        .filter((element) => element.name !== 'Registros Profesionales')
        .filter((element) => element.name !== 'Conciliador de Cobranzas')
        .filter((element) => element.name !== 'Estado de Cola')
        .filter((element) => element.name !== 'Indicador de Permanecia')
        .filter((element) => element.name !== 'Registros Ventas TMotos')
        .filter((element) => element.name !== 'Cuotas Mensuales')
        .filter((element) => element.name !== 'Ventas por Dia')
        .filter((element) => element.name !== 'Ventas por Mes')
        .filter((element) => element.name !== 'Recetas Emitidas Periodo')
        .filter((element) => element.name !== 'Datos Del Año')
        .filter((element) => element.name !== 'Ventas por link')
        .filter((element) => element.name !== 'NC a emitir')
        .filter((element) => element.name !== 'Consultas')
        .filter((element) => element.name !== 'Cola de ABM')
        .filter((element) => element.name !== 'Carta Vigente Obra Social')
        .filter((element) => element.name !== 'Ultimos Aprobados')
        .filter((element) => element.name !== 'Listado de BNF')
        .filter((element) => element.name !== 'Cartera')
        .filter((element) => element.name !== 'RegistroAltasMensualesVD')
        .filter((element) => element.name !== 'Clientes')
        .filter((element) => element.name !== 'Planes')
        .filter((element) => element.name !== 'Estadisticas Puntos De Venta')
        .filter((element) => element.name !== 'Cobros del Mes')
        .filter((element) => element.name !== 'Cápitas')
        .filter((element) => element.name !== 'Reporte Altas Gerencia')
        .filter((element) => element.name !== 'Vademecum')
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}
export const getAllReports = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        return response.data;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}
export const getReportsDashboard = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data.filter((element) => element.name === 'Dashboard')
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}

export const getReportsErrorDatos = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data.filter((element) => element.name === 'Error Triunfo Motos')
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}

export const getReportsGigaRed = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data.filter((element) => element.name === 'Reporte Altas GigaRed')
        //console.log(reports);
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}

export const getReportsVoyEnBus = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data.filter((element) => element.name === 'Ventas Voy En Bus')
        //console.log(reports);
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}

export const getReportsLowMember = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data.filter((element) => element.name === 'Bajas Socios')
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}

export const getReportsVademeum = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data.filter((element) => element.name === 'Vademecum')
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReportsVademeum error: " + error.message)
    });
}

export const getReportsRegisterProfessional = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data.filter((element) => element.name === 'Registros Profesionales')
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}

export const getReportsCollectionsConciliator = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data.filter((element) => element.name === 'Conciliador de Cobranzas')
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}

export const getReportsStatusQueue = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data.filter((element) => element.name === 'Estado de Cola')
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}

export const getReportsPermanencyIndicator = async (token, displayError = () => {}) => {
    return await axios.get(reportsUrl,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        const reports = response.data.filter((element) => element.name === 'Indicador de Permanecia')
        return reports;
    })
    .catch((error) => {
        if(token) displayError("getReports error: " + error.message)
    });
}